import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { AuthorCardsContainerProps } from "~/components/article/article-author-details/styles";
import type { authorBioAuthor$key } from "~/queries/__generated__/authorBioAuthor.graphql";

import { StyledDiv } from "./styles";

export type Props = {
  reference: authorBioAuthor$key;
  variant?: AuthorCardsContainerProps["$variant"];
};

export const AuthorBio: FunctionComponent<Props> = ({ reference: reference_, variant }) => {
  const author = useFragment(
    graphql`
      fragment authorBioAuthor on Author {
        bio
      }
    `,
    reference_,
  );

  return <StyledDiv $variant={variant}>{author.bio}</StyledDiv>;
};

AuthorBio.displayName = "AuthorBio";
